import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Modal,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Grid,
    useTheme,
    Paper,
    TableContainer
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { green, red } from "@mui/material/colors";
import { Tooltip } from '@mui/material';



import { CircularProgress, InputAdornment } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import GetAppIcon from '@mui/icons-material/GetApp';


import { IconButton } from "@mui/material";

import { useFormik, FieldArray, FormikProvider } from "formik";
import Swal from "sweetalert2";
import { tokens } from '../../theme'
import { djangoApi } from "../../utils/axios/axios.utils";

import { formatToBRL } from "../../utils/formats";
import * as Yup from "yup";



const textFieldStyles = {
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: '#b0b0b0', // borda cinza
            border: '0.5px solid #b0b0b0'
        },
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: '#b0b0b0', // label cinza
    },
}


const validationSchema = Yup.object().shape({
    cpfCnpj: Yup.string().required("CPF/CNPJ é obrigatório"),
    nome: Yup.string().required("Nome é obrigatório"),
    telefone: Yup.string().required("Telefone é obrigatório"),
    cep: Yup.string().required("CEP é obrigatório"),
    bairro: Yup.string().required("Bairro é obrigatório"),
    localidade: Yup.string().required("Cidade é obrigatória"),
    uf: Yup.string().required("UF é obrigatória"),
    numero: Yup.string().required("Número é Obrigatório"),
    logradouro: Yup.string().required("Logradouro é obrigatório"),
    formaPagamento: Yup.string().required("Forma de pagamento é obrigatória"),
    produtos: Yup.array()
        .of(
            Yup.object().shape({
                id: Yup.string().required(),
                nome: Yup.string().required(),
                valor: Yup.number().required(),
                quantidade: Yup.number().required().min(1, "Quantidade deve ser maior que 0"),
            })
        )
        .min(1, "Adicione pelo menos um produto"),
    valorTotal: Yup.number()
        .required("Valor total é obrigatório")
        .min(1, "Valor total deve ser maior que 0"),
});

const NotasFiscaisPage = () => {
    const [notas, setNotas] = useState([]);
    const [loadingNfs, setLoadingNfs] = useState(true);
    const [open, setOpen] = useState(false);
    const [produtoId, setProdutoId] = useState("");
    const [loadingCep, setLoadingCep] = useState(false);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [produtos, setProdutos] = useState([]);
    const [loading, setLoading] = useState(false);


    const getNfs = async () => {
        setLoadingNfs(true)
        try {
            const res = await djangoApi
                .get("products/nota_fiscal/get_notas_fiscais_whitout_kit/", {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            // console.log('res: ', res)
            const { status } = res
            if (status === 200) {
                const newNfs = res?.data?.notas_fiscais
                // console.log('newNfs', newNfs)
                setNotas(newNfs)
                setLoadingNfs(false)
            }
        } catch (e) {
            console.log("erro em pegar as NFs: ", e)
            setLoadingNfs(false)
        } finally {
            setLoadingNfs(false)
        }
    }




    useEffect(() => {
        const getNfs = async () => {
            setLoadingNfs(true)
            try {
                const res = await djangoApi
                    .get("products/nota_fiscal/get_notas_fiscais_whitout_kit/", {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    })
                // console.log('res: ', res)
                const { status } = res
                if (status === 200) {
                    const newNfs = res?.data?.notas_fiscais
                    console.log('newNfs', newNfs)
                    setNotas(newNfs)
                    setLoadingNfs(false)
                }
            } catch (e) {
                console.log("erro em pegar as NFs: ", e)
                setLoadingNfs(false)
            } finally {
                setLoadingNfs(false)
            }
        }
        getNfs()

    }, []);


    const buildDestinatario = (values) => {
        return {
            nome_destinatario: values.nome || "",
            cpf_destinatario: values.cpfCnpj || "",
            telefone_destinatario: values.telefone.replace(/\+55/, ""), // remove +55 se existir
            logradouro_destinatario: values.logradouro || "",
            numero_destinatario: values.numero || "0", // se tiver campo separado, ou "" se não
            bairro_destinatario: values.bairro || "",
            municipio_destinatario: values.localidade || "",
            uf_destinatario: values.uf || "",
            pais_destinatario: "Brasil",
            cep_destinatario: values.cep || "",
        };
    };

    const transformProdutosToSend = (produtos) => {
        const itemTemplate = {
            unidade_comercial: "un",
            unidade_tributavel: "un",
            cfop: "5102",
            icms_situacao_tributaria: "102",
            icms_origem: "0",
            pis_situacao_tributaria: "07",
            cofins_situacao_tributaria: "07"
        };

        const itemsFormated = [];

        produtos.forEach((prod, index) => {
            const quantitySold = prod.quantidade; // quantidade selecionada no form
            if (quantitySold > 0) {
                itemsFormated.push({
                    ...itemTemplate,
                    color_prod: prod.color || "", // ou outro campo se houver
                    numero_item: index + 1,
                    codigo_produto: prod.nome,
                    descricao: prod.color === 'Prata 925' ? prod.model + `${" " + prod.color}` : prod.model,
                    quantidade_comercial: quantitySold,
                    valor_unitario_comercial: prod.valor,
                    valor_unitario_tributavel: prod.valor,
                    quantidade_tributavel: quantitySold,
                    valor_bruto: quantitySold * prod.valor,
                });
            }
        });

        const totalProdsValue = itemsFormated.reduce(
            (acc, curr) => acc + curr.valor_bruto,
            0
        );

        return { itemsFormated, totalProdsValue };
    };


    const formik = useFormik({
        initialValues: {
            cpfCnpj: "",
            nome: "",
            telefone: "",
            cep: "",
            logradouro: "",
            numero: "",
            bairro: "",
            localidade: "",
            uf: "",
            produtos: [],  // <<< essencial para FieldArray
            valorTotal: 0,
            valorTotalSugerido: 0,
        },
        validationSchema,  // ✅ aqui entra a validação
        onSubmit: async (values) => {
            console.log('Values Here', values)
            const destinatario = buildDestinatario(values);
            const { itemsFormated, totalProdsValue } = transformProdutosToSend(values.produtos);

            const payload = {
                sellerData: destinatario,
                homologa: false,
                // kit_id: 'data.kit_pk',
                items: itemsFormated,
                totalValue: values.valorTotal,
                totalValueProds: totalProdsValue,
                formas_pagamento: [
                    {
                        "forma_pagamento": values.formaPagamento,
                        "valor_pagamento": `${values.valorTotal}`,
                    }
                ],
                // CAMPOS NOVOS
                nome: values.nome,
                cpfCnpj: values.cpfCnpj,
                avulso: true
            }

            // Construir lista de produtos para mostrar no Swal
            const produtosTable = `
                <table style="width:100%; border-collapse: collapse;">
                    <thead>
                        <tr>
                            <th style="border-bottom: 1px solid #ccc; text-align:left; padding:4px;">Produto</th>
                            <th style="border-bottom: 1px solid #ccc; text-align:left; padding:4px ;padding-left: 12px;">Tipo</th>
                            <th style="border-bottom: 1px solid #ccc; text-align:left; padding:4px ;padding-left: 12px;">Cor</th>
                            <th style="border-bottom: 1px solid #ccc; text-align:right; padding:4px;">Valor </th>
                        </tr>
                    </thead>
                    <tbody>
                        ${values.produtos.map(p => `
                            <tr>
                                <td style="padding:4px; text-align:left;">${p.nome}</td>
                                <td style="padding:4px ;padding-left: 12px;text-align:left;">${p.model}</td>
                                <td style="padding:4px; text-align:left;">${p.color}</td>
                                <td style="padding:4px; text-align:right;">${formatToBRL(p.valor)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            `;
            // Mostrar Swal de confirmação
            const result = await Swal.fire({
                title: 'Confirme os dados da Nota Fiscal',
                html: `
            <b>Valor Total:</b> ${formatToBRL(values.valorTotal)} <br>
            <b>Cliente:</b> ${values.nome} <br>
            <b>CPF/CNPJ:</b> ${values.cpfCnpj} <br>
            <br>
            ${produtosTable}
        `,
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
                width: 600,
                scrollbarPadding: false
            });

            if (result.isConfirmed) {
                console.log('payloadHere', payload)
                try {
                    Swal.fire({
                        title: "Enviando Nota Fiscal...",
                        html: "Aguarde enquanto processamos sua solicitação.",
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    const res = await djangoApi
                        .post("products/nota_fiscal/create_nota_fiscal_whitout_kit/", payload, {
                            headers: {
                                Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                                "Content-Type": "application/json"
                            }
                        })
                    console.log('res: ', res)
                    if (res.status === 201) {
                        Swal.fire("Sucesso", "Nota Fiscal emitida!", "success");
                        setOpen(false);
                        formik.resetForm();
                        getNfs()
                        const { status } = res;
                        console.log('status res: ', status)
                        console.log('response Homologacao: ', res);
                        console.log(res.data.nota_fiscal_url);
                    } else {
                        Swal.fire("Erro", "Falha ao emitir NF", "error");
                    }
                } catch (e) {
                    Swal.fire("Erro", "Falha de comunicação", "error");
                    console.log('erro ao emitir a NF', e)
                }
            }
            else {
                // Cancelou a confirmação
                Swal.fire("Cancelado", "A emissão da NF foi cancelada.", "info");
            }
        },
    });

    const handleCancel = (notaId, nfNumber) => {
        Swal.fire({
            title: `Cancelar Nota Fiscal Nº ${nfNumber}`,
            input: "textarea",
            inputLabel: "Observações / Justificativa",
            inputPlaceholder: "Digite aqui o motivo do cancelamento...",
            inputAttributes: {
                "aria-label": "Observações / Justificativa"
            },
            showCancelButton: true,
            confirmButtonText: "Cancelar NF",
            confirmButtonColor: "#d33",
            cancelButtonText: "Fechar",
            reverseButtons: true, // 👈 inverte a ordem
            preConfirm: async (justificativa) => {
                if (!justificativa) {
                    Swal.showValidationMessage("É necessário informar uma justificativa");
                    return false;
                }
                try {
                    Swal.fire({
                        title: "Cancelando Nota Fiscal...",
                        html: "Aguarde enquanto processamos o cancelamento.",
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });

                    const payload = {
                        justificativa,
                        homologa: false,
                    };

                    const response = await djangoApi.post(
                        `products/nota_fiscal/${notaId}/delete_nota_fiscal_whitout_kit/`,
                        payload,
                        {
                            headers: {
                                Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                                "Content-Type": "application/json"
                            }
                        }
                    );

                    if (![200, 201, 204].includes(response.status)) {
                        throw new Error("Erro ao cancelar NF");
                    }

                    Swal.fire("Sucesso", "Nota Fiscal Cancelada!", "success");
                    getNfs();
                    return true;
                } catch (err) {
                    Swal.showValidationMessage(`Falha: ${err.message}`);
                    return false;
                }
            },
        });
    };

    const handleCepChange = async (e) => {
        const cepInput = e.target.value.replace(/\D/g, "");
        formik.setFieldValue("cep", e.target.value); // mantém o CEP que está digitando

        // Se CEP está vazio ou incompleto, limpa apenas os campos do endereço
        if (cepInput.length < 8) {
            formik.setFieldValue("logradouro", "");
            formik.setFieldValue("bairro", "");
            formik.setFieldValue("localidade", "");
            formik.setFieldValue("uf", "");
            return;
        }

        try {
            setLoadingCep(true);
            const res = await fetch(`https://brasilapi.com.br/api/cep/v1/${cepInput}`);
            const data = await res.json();

            if (data.cep) {
                formik.setFieldValue("logradouro", data.street || "");
                formik.setFieldValue("bairro", data.neighborhood || "");
                formik.setFieldValue("localidade", data.city || "");
                formik.setFieldValue("uf", data.state || "");
            } else {
                // CEP inválido: limpa apenas os campos do endereço
                formik.setFieldValue("logradouro", "");
                formik.setFieldValue("bairro", "");
                formik.setFieldValue("localidade", "");
                formik.setFieldValue("uf", "");
                Swal.fire("Erro", "CEP não encontrado", "error");
            }
        } catch {
            formik.setFieldValue("logradouro", "");
            formik.setFieldValue("bairro", "");
            formik.setFieldValue("localidade", "");
            formik.setFieldValue("uf", "");
            Swal.fire("Erro", "Falha ao buscar CEP", "error");
        } finally {
            setLoadingCep(false);
        }
    };

    const handleProdutoChange = async (e, push, form) => {
        const value = e.target.value;
        setProdutoId(value);
        const showMissing = true;

        if (value.length === 6) {
            try {
                setLoading(true); // inicia spinner

                const response = await djangoApi.get(
                    `products/register_prods/${value}/get_list_kits_prods_sellers_in/?show_missing=${showMissing}`,
                    {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    }
                );

                const { data, status } = response;

                if (status !== 200) {
                    throw new Error("Produto não encontrado");
                }

                console.log("produto recebido:", data);
                const prod = data.data.prod;
                if (prod) {

                    const produto = {
                        id: prod.id,
                        nome: prod.id_produto,
                        valor: prod.charged_price,
                        model: prod.model,
                        quantidadeDisponivel: prod.quantity_available,
                        imagem: prod.imageUrl,
                        color: prod.color
                    };

                    push({ ...produto, quantidade: 1 });

                    const novoTotal = (form.values.valorTotalSugerido || 0) + produto.valor;
                    form.setFieldValue("valorTotalSugerido", novoTotal);

                    setProdutos((prev) => [...prev, produto]);
                    setProdutoId("");
                } else {
                    throw new Error("Produto Sem Informações");
                }
            } catch (err) {
                Swal.fire("Erro", err.message || "Erro ao buscar produto", "error");
            } finally {
                setLoading(false); // encerra spinner
            }
        }
    };

    const totalSugerido = formik.values.produtos.reduce(
        (acc, p) => acc + (p.valor * p.quantidade),
        0
    );
    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // meses começam em 0
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }


    if (loadingNfs) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress size={60} color="inherit" />
            </Box>
        )
    }


    return (
        <Box className="max-w-5xl mx-auto p-6" mt={10} pl={2} pr={2}>
            <Typography variant="h4" gutterBottom >
                Notas Fiscais
                <Box mt={2} mb={1}>
                    <Button variant="contained" color="success" onClick={() => setOpen(true)}>
                        Emitir Nova NF
                    </Button>
                </Box>
            </Typography>

            {/* Tabela de Notas Fiscais */}
            <TableContainer component={Paper} sx={{ maxHeight: '80vh' }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                sx={{ backgroundColor: colors.pink[800], color: "white", fontWeight: "bold" }}
                            >
                                Status
                            </TableCell>
                            <TableCell
                                sx={{ backgroundColor: colors.pink[800], color: "white", fontWeight: "bold" }}
                            >
                                Data
                            </TableCell>
                            <TableCell
                                sx={{ backgroundColor: colors.pink[800], color: "white", fontWeight: "bold" }}
                            >
                                NF Nº
                            </TableCell>
                            <TableCell
                                sx={{ backgroundColor: colors.pink[800], color: "white", fontWeight: "bold" }}
                            >
                                Cliente
                            </TableCell>
                            <TableCell
                                sx={{ backgroundColor: colors.pink[800], color: "white", fontWeight: "bold" }}
                            >
                                Valor
                            </TableCell>
                            <TableCell
                                sx={{ backgroundColor: colors.pink[800], color: "white", fontWeight: "bold" }}
                            >
                                PDF
                            </TableCell>
                            <TableCell
                                sx={{ backgroundColor: colors.pink[800], color: "white", fontWeight: "bold" }}
                            >
                                Cancelar
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {notas.map((n, index) => (
                            <TableRow
                                key={n.id}
                                sx={{
                                    backgroundColor: index % 2 === 0 ? "#f5f5f5" : "#e0e0e0", // dois tons de cinza
                                    "&:hover": { backgroundColor: "#cccccc" }, // hover mais escuro
                                }}

                            >
                                <TableCell align="left" width={'100px'}>
                                    {n.ativo ? (
                                        <CheckCircleIcon sx={{ color: green[500] }} />
                                    ) : (
                                        <CancelIcon sx={{ color: red[500] }} />
                                    )}
                                </TableCell>
                                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>{formatDate(n.criados)}</TableCell>
                                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>{n.numero_nf}</TableCell>
                                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>{n.nome}</TableCell>
                                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>{formatToBRL(n?.data_nf?.valor_total)}</TableCell>
                                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                                    {n.path_nf ? (
                                        <IconButton
                                            component="a"
                                            href={n.path_nf}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            color={n.ativo ? "inherit" : 'warning'}
                                        >
                                            <PictureAsPdfIcon />
                                        </IconButton>
                                    ) : (
                                        "-"
                                    )}
                                    {n.path_xml && (
                                        <Tooltip title="XML NF">
                                            <IconButton
                                                component="a"
                                                href={n.path_xml}
                                                download={`NF_${n.numero_nf}.xml`}
                                                color="primary"
                                            >
                                                <GetAppIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}

                                    {!n.ativo && n.path_xml_cancel && (
                                        <Tooltip title="XML NF Cancelada">
                                            <IconButton
                                                component="a"
                                                href={n.path_xml_cancel}
                                                download={`NF_${n.numero_nf}_cancelada.xml`}
                                                color="warning"
                                            >
                                                <GetAppIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </TableCell>
                                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                                    {n.ativo ?
                                        <IconButton
                                            color="error"
                                            onClick={() => handleCancel(n.id, n.numero_nf)}
                                        >
                                            <CancelIcon />
                                        </IconButton>

                                        :
                                        <Box pl={2}>-</Box>
                                    }

                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


            {/* Modal do Formulário */}
            <Modal open={open} onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    setOpen(false);
                }
            }}

                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)", // deixa mais escuro
                        },
                    },
                }}

            >
                <FormikProvider value={formik}>
                    <Box
                        component="form"
                        onSubmit={formik.handleSubmit}
                        sx={{
                            backgroundColor: colors.pink[700],
                            p: 0,
                            m: "auto",
                            mt: "2%",
                            width: "90%",
                            height: "95%",
                            borderRadius: 2,
                            boxShadow: 20,
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* HEADER FIXO */}
                        <Box
                            sx={{
                                p: 2,
                                borderBottom: `1px solid ${colors.pink[500]}`,
                                backgroundColor: colors.pink[800],
                                position: "sticky",
                                top: 0,
                                zIndex: 10,
                            }}
                        >
                            <Typography variant="h3" color={colors.greenAccent[400]} fontWeight="bold">
                                Emitir Nota Fiscal
                            </Typography>
                        </Box>

                        {/* CONTEÚDO SCROLLÁVEL */}
                        <Box
                            sx={{
                                p: 4,
                                overflow: 'auto'
                            }}
                        >
                            {/* Dados do Cliente */}
                            <Box
                                component={Paper}
                                elevation={8}
                                sx={{
                                    backgroundColor: colors.pink[700],
                                    padding: "30px",
                                    borderRadius: "6px",
                                }}
                                mt={2}
                            >
                                <Typography variant="h4" mb={3} fontWeight="bold" color={colors.primary[100]}>
                                    Dados do Cliente
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <TextField
                                            fullWidth
                                            label="CPF/CNPJ"
                                            name="cpfCnpj"
                                            value={formik.values.cpfCnpj}
                                            onChange={formik.handleChange}
                                            sx={textFieldStyles}
                                            error={formik.touched.cpfCnpj && Boolean(formik.errors.cpfCnpj)}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            sx={textFieldStyles}
                                            fullWidth
                                            label="Nome"
                                            name="nome"
                                            value={formik.values.nome}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            sx={textFieldStyles}
                                            fullWidth
                                            label="Telefone"
                                            name="telefone"
                                            value={formik.values.telefone}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>


                            {/* Endereço */}
                            <Box
                                component={Paper}
                                elevation={8}
                                sx={{
                                    backgroundColor: colors.pink[700],
                                    padding: '30px',
                                    borderRadius: '6px'
                                }}
                                mt={2}
                            >
                                <Typography variant="h4" mb={3} fontWeight={"bold"} color={colors.primary[100]}>
                                    Endereço
                                </Typography>
                                <Grid container spacing={4}>
                                    <Grid item xs={3}>
                                        <TextField
                                            sx={textFieldStyles}
                                            fullWidth
                                            label="CEP"
                                            name="cep"
                                            value={formik.values.cep}
                                            onChange={handleCepChange}
                                            InputProps={{
                                                endAdornment: loadingCep ? (
                                                    <InputAdornment position="end">
                                                        <CircularProgress size={20} color="success" />
                                                    </InputAdornment>
                                                ) : null,
                                                inputProps: { maxLength: 8 }, // limite de 8 caracteres
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <TextField
                                            sx={textFieldStyles}
                                            fullWidth
                                            label="Bairro"
                                            name="bairro"
                                            value={formik.values.bairro}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            sx={textFieldStyles}
                                            fullWidth
                                            label="Cidade"
                                            name="localidade"
                                            value={formik.values.localidade}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField
                                            sx={textFieldStyles}
                                            fullWidth
                                            label="UF"
                                            name="uf"
                                            value={formik.values.uf}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <TextField
                                            sx={textFieldStyles}
                                            fullWidth
                                            label="Logradouro"
                                            name="logradouro"
                                            value={formik.values.logradouro}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField
                                            sx={textFieldStyles}
                                            fullWidth
                                            label="Número"
                                            name="numero"
                                            value={formik.values.numero}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>


                            {/* Produtos */}
                            <Box
                                component={Paper}
                                elevation={8}
                                sx={{
                                    backgroundColor: colors.pink[700],
                                    padding: '30px',
                                    borderRadius: '6px'
                                }}
                                mt={2}
                            >
                                <Typography variant="h4" mb={3} fontWeight={"bold"} color={colors.primary[100]}>
                                    Produtos  {totalSugerido > 0 && " - " + formatToBRL(totalSugerido)}
                                </Typography>
                                <FieldArray name="produtos">
                                    {({ remove, push, form }) => {
                                        const produtosArray = form.values.produtos || [];
                                        return (
                                            <Box>
                                                <Box display="flex" gap={2} mb={2}>
                                                    <TextField
                                                        sx={textFieldStyles}
                                                        label="ID Produto"
                                                        disabled={loading}
                                                        value={produtoId}
                                                        onChange={(e) => handleProdutoChange(e, push, form)}
                                                        InputProps={{
                                                            endAdornment: loading ? (
                                                                <CircularProgress size={20} color="inherit" />
                                                            ) : null
                                                        }}
                                                    />

                                                    <FormControl variant="outlined" sx={{ width: '300px', ...textFieldStyles }}>
                                                        <InputLabel id="payment-select-label">Forma de Pagamento</InputLabel>
                                                        <Select
                                                            size="small"
                                                            labelId="payment-select-label"
                                                            value={form.values.formaPagamento || ""}
                                                            onChange={(e) => form.setFieldValue("formaPagamento", e.target.value)}
                                                            label="Forma de Pagamento"
                                                        >
                                                            <MenuItem value="01">Dinheiro</MenuItem>
                                                            <MenuItem value="03">Cartão de Crédito</MenuItem>
                                                            <MenuItem value="99">Outros</MenuItem>
                                                        </Select>
                                                    </FormControl>

                                                </Box>


                                                {produtosArray?.length > 0 &&

                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow sx={{ backgroundColor: colors.pink[800] }}>
                                                                <TableCell sx={{ color: colors.grey[100], fontWeight: "bold", fontSize: '1.3em' }}>Produto</TableCell>
                                                                <TableCell sx={{ color: colors.grey[100], fontWeight: "bold", fontSize: '1.3em' }}>Tipo</TableCell>
                                                                <TableCell sx={{ color: colors.grey[100], fontWeight: "bold", fontSize: '1.3em' }}>Cor</TableCell>
                                                                <TableCell sx={{ color: colors.grey[100], fontWeight: "bold", fontSize: '1.3em' }}>Valor Unitário</TableCell>
                                                                <TableCell sx={{ color: colors.grey[100], fontWeight: "bold", fontSize: '1.3em' }}>Quantidade</TableCell>
                                                                <TableCell sx={{ color: colors.grey[100], fontWeight: "bold", fontSize: '1.3em' }}>Total</TableCell>
                                                                <TableCell sx={{ color: colors.grey[100], fontWeight: "bold", fontSize: '1.3em', textAlign: 'right', paddingRight: '30px' }}>Ações</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {produtosArray.map((p, index) => (
                                                                <TableRow
                                                                    key={index}
                                                                    sx={{ backgroundColor: index % 2 === 0 ? colors.pink[600] : colors.pink[700] }}
                                                                >
                                                                    <TableCell sx={{ color: colors.grey[200], fontSize: '1.2em' }}>{p.nome}</TableCell>
                                                                    <TableCell sx={{ color: colors.grey[200], fontSize: '1.2em' }}>{p.model}</TableCell>
                                                                    <TableCell sx={{ color: colors.grey[200], fontSize: '1.2em' }}>{p.color}</TableCell>
                                                                    <TableCell sx={{ color: colors.grey[200], fontSize: '1.2em' }}>
                                                                        <TextField
                                                                            name={`produtos[${index}].valor`}
                                                                            type="number"
                                                                            size="small"
                                                                            value={form.values.produtos[index].valor}
                                                                            onChange={(e) =>
                                                                                form.setFieldValue(`produtos[${index}].valor`, parseFloat(e.target.value) || 0)
                                                                            }
                                                                        // InputProps={{
                                                                        //     sx: { color: colors.grey[200], fontSize: '1em', maxWidth: '120px' },
                                                                        // }}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ color: colors.grey[200], fontSize: '1.2em' }}>
                                                                        {p.quantidade}  {/* ✅ Aqui estava faltando */}
                                                                    </TableCell>
                                                                    <TableCell sx={{ color: colors.grey[200], fontSize: '1.2em' }}>
                                                                        {formatToBRL(form.values.produtos[index].valor * p.quantidade)}
                                                                    </TableCell>
                                                                    <TableCell sx={{ textAlign: 'right' }}>
                                                                        <Button
                                                                            size="small"
                                                                            variant="outlined"
                                                                            color="warning"
                                                                            onClick={() => remove(index)}
                                                                        >
                                                                            Remover
                                                                        </Button>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                }

                                            </Box>
                                        );
                                    }}
                                </FieldArray>
                            </Box>


                            {/* Valor Total */}
                            <Box
                                component={Paper}
                                elevation={8}
                                sx={{
                                    backgroundColor: colors.pink[700],
                                    padding: '30px',
                                    borderRadius: '6px'
                                }}
                                mt={2}
                            >
                                <Typography variant="h4" mb={3} fontWeight={"bold"} color={colors.primary[100]} >
                                    Valor da Nota Fiscal
                                </Typography>
                                <TextField
                                    // fullWidth
                                    label="Valor Total"
                                    name="valorTotal"
                                    type="number"
                                    value={formik.values.valorTotal}
                                    onChange={formik.handleChange}
                                    sx={textFieldStyles}
                                />
                            </Box>

                            {/* Botões */}
                            <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
                                <Button
                                    variant="outlined"
                                    color="warning"
                                    onClick={() => {
                                        formik.resetForm();
                                        setOpen(false);
                                    }}
                                >
                                    Cancelar
                                </Button>
                                <Button type="submit" variant="contained" color="success"
                                    disabled={!(formik.isValid)} // ✅ só habilita quando válido

                                >
                                    Emitir Nota Fiscal
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </FormikProvider>
            </Modal>
        </Box>
    );
};

export default NotasFiscaisPage;